module.exports = __webpack_public_path__ + "static/discount4-a59d1546feee7d55b8881363b16ead5c.jpg";